var _sentryCollisionFreeGlobalObject = typeof window != "undefined" ? window : typeof global != "undefined" ? global : typeof self != "undefined" ? self : {};
_sentryCollisionFreeGlobalObject["__sentryRewritesTunnelPath__"] = undefined;
_sentryCollisionFreeGlobalObject["SENTRY_RELEASE"] = {"id":"PT_2_GR63ocFSiSJMZSlw"};
_sentryCollisionFreeGlobalObject["__sentryBasePath"] = undefined;
_sentryCollisionFreeGlobalObject["__rewriteFramesAssetPrefixPath__"] = "";

import * as Sentry from "@sentry/nextjs";

Sentry.init({
  dsn: "https://303c1ce0890d42e99c040fc293849224@o151188.ingest.sentry.io/4505170768232448",
  denyUrls: [
    // Chrome extensions
    /extensions\//i,
    /^chrome:\/\//i,

    // third party scripts
    /connect\.facebook\.net/i,
    /\.smartlook\.(com|cloud)/i,
    /bat\.bing\.com/i,
    /snap\.licdn\.com/i,
    /google-analytics\.com/i,
    /googletagmanager\.com\//i,
    /widget\.trustpilot\.com/i,
    /script\.tapfiliate\.com/i,
    /\.g\.doubleclick\.net/i,
    /\.clickcease\.com/i,
    /\.ads\.linkedin\.com/i,
    /\.googleapis\.com/i,
    /localhost/i,
  ],
  environment: process.env.IS_LIVE ? "production" : "development",
  debug: false,
});
